import ProductLink from '../../../../products/common/components/ProductLink';

const Title = (props) => {
  const { item, isLink = true } = props;

  const { productSlug, productId, productTitle } = item;

  let title = item.productTitle;
  if (isLink) {
    title = (
      <ProductLink
        product={{ slug: productSlug, id: productId, title: productTitle }}
        linkType="Window"
        key={productId}
      >
        {item.productTitle}
      </ProductLink>
    );
  }

  return (
    <>
      <div className="c7-order-item__title" role="heading" aria-level="3">
        {title}
      </div>
      <div className="c7-order-item__description">
        {item.productVariantTitle}
      </div>
    </>
  );
};

export default Title;
